'use strict';

export function DataTagLinkDomainProvider() {
  return {
    $get: [
      '$injector',
      'AbstractDomainClass',
      'OrgIdMixin',
      function ($injector, AbstractDomainClass, OrgIdMixin) {
        // Service locator pattern
        var FormResponseDomain;

        // TODO: implement immutable support and flag this class immutable
        function DataTagLinkDomain(data) {
          AbstractDomainClass.call(this, DataTagLinkDomain, data);
        }

        AbstractDomainClass.__inheritFrom(DataTagLinkDomain, 'DataTagLinkDomain', 'data-tag-links');
        OrgIdMixin(DataTagLinkDomain);

        DataTagLinkDomain.$constraints.addConstraints({
          tag: {type: 'string'},
          taggable: {type: 'DomainLink', links: 'data-tags', belongsTo: true},
          response: {type: 'string', nullable: true},
          org: {type: 'string'}, // Organization ID
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'}
        });

        // more methods go here;

        DataTagLinkDomain.prototype.getResponse = getResponse;
        DataTagLinkDomain.prototype.toString = toString;

        function getResponse() {
          __loadServices();

          if (this.response)
            return FormResponseDomain.$get(this.response);
          else
            return Promise.resolve(null);
        }

        function toString() {
          return this.tag && this.tag.name;
        }

        function __loadServices() {
          if (FormResponseDomain)
            return;
          FormResponseDomain = $injector.get('FormResponseDomain');
        }

        return DataTagLinkDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/data-tags/domain/DataTagLinkDomain.js